import { AxiosResponse } from "axios";

import ApiService from "./apiService";
import { BEConfig } from "../config/env";
import { webapiGet, webapiPost } from "../webapis/core";

export type FollowedBrand = {
  brandId: number;
  brandName: string;
  followedAt: string;
};

type FollowedBrandsResponse = { followedBrands: FollowedBrand[] };
type FollowStatusResponse = { brandId: number; isFollowing: boolean };

class FollowedBrandsService extends ApiService {
  private getBaseUrl() {
    const { baseURL, protocol, port, versionInfo } = BEConfig.customerApi;
    return `${protocol}${baseURL}${port}${versionInfo}`;
  }

  async followBrand(brandId: number, brandName: string): Promise<void> {
    const url = `${this.getBaseUrl()}${BEConfig.customerApi.brandFollowHandle}`;
    await webapiPost(
      this.getAccessToken(),
      url,
      { brandId, brandName },
      this.getVisitorId()
    ).request;
  }

  async unfollowBrand(brandId: number): Promise<void> {
    const url = `${this.getBaseUrl()}${
      BEConfig.customerApi.brandUnfollowHandle
    }`;
    await webapiPost(
      this.getAccessToken(),
      url,
      { brandId },
      this.getVisitorId()
    ).request;
  }

  async getFollowStatus(brandId: number): Promise<boolean> {
    const url = `${this.getBaseUrl()}${
      BEConfig.customerApi.brandFollowStatusHandle
    }/${brandId}`;
    const response: AxiosResponse<FollowStatusResponse> = await webapiGet(
      this.getAccessToken(),
      url,
      this.getVisitorId()
    ).request;

    return Boolean(response.data.isFollowing);
  }

  async getFollowedBrands(): Promise<FollowedBrand[]> {
    const url = `${this.getBaseUrl()}${
      BEConfig.customerApi.brandFollowedListHandle
    }`;
    const response: AxiosResponse<FollowedBrandsResponse> = await webapiGet(
      this.getAccessToken(),
      url,
      this.getVisitorId()
    ).request;

    return response.data.followedBrands ?? [];
  }
}

const instance = new FollowedBrandsService();

export default instance;
